import { DefaultTemplate } from '@payloadcms/next/templates';
import { SetStepNav } from '@payloadcms/ui';
import { redirect } from 'next/navigation';
import type { AdminViewServerProps } from 'payload';
import React from 'react';
import './Llm.scss';
import { LlmTestClient } from './LlmTestClient';

export const LlmTest: React.FC<AdminViewServerProps> = async (props) => {
  const { payload, locale, i18n, initPageResult, clientConfig, importMap, params, searchParams } = props;
  const config = payload.config;
  const { routes, collections } = config;
  const user = initPageResult.req?.user || undefined;
  const permissions = initPageResult.permissions;
  const visibleEntities = initPageResult.visibleEntities;
  console.log('LlmTest.permissions', permissions);

  if (!user || (user && !permissions.canAccessAdmin)) {
    redirect(`${routes.admin}/unauthorized`);
  }

  const nav = [
    {
      label: 'Llm Test', // getTranslation('Llm Test', i18n),
      url: '/llm-test',
    },
  ];

  return (
    <DefaultTemplate
      i18n={initPageResult.req.i18n}
      locale={initPageResult.locale}
      params={params}
      payload={payload}
      permissions={permissions}
      searchParams={searchParams}
      user={user}
      visibleEntities={visibleEntities}
    >
      <SetStepNav nav={nav} />
      <LlmTestClient />
    </DefaultTemplate>
  );
};
